import React from 'react';

export function Textarea({
  label,
  borderAccent,
  className = '',
  style: styleProp,
  id,
  ...props
}) {
  const textareaId = id || (label ? `textarea-${label.replace(/\s+/g, '-').toLowerCase()}` : undefined);

  return (
    <div className="space-y-1">
      {label && (
        <label
          htmlFor={textareaId}
          className="text-label flex items-center gap-1"
        >
          {label}
        </label>
      )}
      <textarea
        id={textareaId}
        className={`w-full rounded-lg p-2 text-xs outline-none resize-none transition-colors border focus-visible:outline-2 focus-visible:outline-offset-2 ${className}`}
        style={{
          backgroundColor: 'var(--color-bg-primary)',
          borderColor: borderAccent || 'var(--color-border-primary)',
          color: 'var(--color-text-primary)',
          ...styleProp,
        }}
        {...props}
      />
    </div>
  );
}
